"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationOverviewTableOptions = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
require("./index.scss");
const ReservationOverviewTableOptions = (props) => {
    const { options, className } = props;
    const classNames = (0, classnames_1.default)('reservation-overview-table-options', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames },
        options.length > 0 && (react_1.default.createElement("div", { className: 'reservation-overview-info-table__title' },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepReservationOverview/ReservationOverviewInfo/ReservationOverviewTableOptions:OptionsTitle', defaultMessage: 'Options' }))),
        options.map((option, idx) => (react_1.default.createElement("p", { key: idx, className: 'reservation-overview-table-options__item' }, option)))));
};
exports.ReservationOverviewTableOptions = ReservationOverviewTableOptions;
//# sourceMappingURL=index.js.map